import React from 'react';

import { useSelector, useDispatch } from 'react-redux';

import analyticsUtils from 'app/client/utils/analyticsUtils';

import ModalConstants from 'app/shared/constants/ModalConstants';
import AnalyticsConstants from 'app/shared/constants/AnalyticsConstants';
import { DELIMITER } from 'app/shared/constants/AnalyticsDelimiterConstants';

import ModalActions from 'app/shared/actions/ModalActions';

import { RMWContext } from 'app/shared/providers/RMWContext';

import { Center } from '@zillow/zrs-comet';

import {
    PropertiesSelectors,
} from 'app/shared/selectors';

import {
    Flex,
    Spacer,
    Text,
    TextButton,
} from '@zillow/constellation';

import {
    StyledMDContainer,
    StyledMDContent,
    StyledMDContentContainer,
} from 'app/shared/containers/ModalContainer/StyledComponents';

import { StyledHR } from './StyledComponents';

const FixIncorrectInformationModal = () => {
    const dispatch = useDispatch();
    const { paths } = React.useContext(RMWContext);
    const { listingAlias, topDupesDetails } = useSelector(state => PropertiesSelectors.makeCurrentProperty(state));

    const handleCreateNewListing = () => {
        dispatch(analyticsUtils.track.GAEventV2(AnalyticsConstants.GA_EVENTS.LISTING_ISSUES_OPTIONS, {
            label: `IncorrectInformation${DELIMITER}CreateNewManualListing`,
        }));
        dispatch(ModalActions.showModal({
            modalType: ModalConstants.TRANSFER_FEED_LISTING_MODAL,
            header: 'Automatically create a new version',
            isFluid: true,
        }));
    };

    const handleSwitchListingSource = () => {
        dispatch(analyticsUtils.track.GAEventV2(AnalyticsConstants.GA_EVENTS.LISTING_ISSUES_OPTIONS, {
            label: `IncorrectInformation${DELIMITER}GoToManualListing`,
        }));
        window.router.transitionTo(`${paths.propertiesPage}/${listingAlias}/${paths.propertyDetailsSources}`);
        dispatch(ModalActions.hideModal());
    };

    const handleEmailClick = () => {
        dispatch(analyticsUtils.track.GAEventV2(AnalyticsConstants.GA_EVENTS.LISTING_ISSUES_OPTIONS, {
            label: `IncorrectInformation${DELIMITER}ContactSupport`,
        }));
        window.location.href = 'mailto:rentalshelp@zillowgroup.com';
        dispatch(ModalActions.hideModal());
    };

    let title = 'Automatically create a new version in Zillow Rental Manager';
    let text = `We’ll make an editable copy of the listing. You can change it in Zillow Rental Manager,
        then publish the new listing.`;
    let cta = 'Fix listing';
    let ctaClick = handleCreateNewListing;

    if (topDupesDetails && topDupesDetails.hasManualDupe) {
        title = 'Update your listing in Zillow Rental Manager';
        text = 'Go to the Zillow Rental Manager version of the listing, update fields and then publish the listing.';
        cta = 'Switch source';
        ctaClick = handleSwitchListingSource;
    }

    return (
        <StyledMDContainer>
            <StyledMDContentContainer>
                <StyledMDContent>
                    <Spacer paddingY="md">
                        <Center>
                            <Flex display="flex" flexDirection="column" alignItems="center">
                                <Text fontType="bodyHeading">{title}</Text>
                                <Text>{text}</Text>
                                <Spacer paddingBottom="xs" />
                                <TextButton onClick={ctaClick}>{cta}</TextButton>
                                <StyledHR color="yellow300" />
                                <Text fontType="bodyHeading">Or you can contact support</Text>
                                <Text>Get help with questions about your listing.</Text>
                                <Spacer paddingBottom="xs" />
                                <TextButton onClick={handleEmailClick}>Email Zillow support</TextButton>
                            </Flex>
                        </Center>
                    </Spacer>
                </StyledMDContent>
            </StyledMDContentContainer>
        </StyledMDContainer>
    );
};

export { FixIncorrectInformationModal };
export default FixIncorrectInformationModal;
